// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationModal-cls1_zf0","cls2":"ConfirmationModal-cls2_oS7 ConfirmationModal-cls1_zf0"};